var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.fieldLabel))]),_vm._v(" "),_c(_setup.NcSelect,_vm._g(_vm._b({staticClass:"edit-multiselect",attrs:{"label-outside":true,"multiple":true}},'NcSelect',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }